import { IMorningStarStyle } from '../models/index.js';
export const morningStarStyle: IMorningStarStyle = {
	display: 'flex',
	flex: {
		wrap: 'wrap',
	},
	justifyContent: 'center',
	width: '100%',
	children: {
		morningStarIconWrapper: {
			min: {
				width: '24px',
			},
		},
	},
};
